import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import { Lang } from './lang'
import axios from './common/axios'
import config from './config'
import { LoadingBar, Message, Notice, Progress } from 'iview'
import VueClipboard from 'vue-clipboard2'
import animate from 'animate.css'
import 'iview/dist/styles/iview.css'
import 'swiper/dist/css/swiper.css';
import 'vant/lib/index.css';
import './assets/css/main.less'
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(VueClipboard)
Vue.use(animate)
Vue.use(VueAwesomeSwiper, )
Vue.component('i-progress', Progress)
LoadingBar.config({
    color: '#50A0FF',
    failedColor: '#F09D4E',
});
Vue.prototype.$Loading = LoadingBar
Vue.prototype.$Message = Message
Vue.prototype.$Notice = Notice
Vue.prototype.$axios = axios
Vue.prototype.$config = config

const i18n = new VueI18n({
    locale: localStorage.getItem('Lang') || 'cn',
    messages: {
        ...Lang
    }
})
localStorage.setItem('Lang', 'cn')
router.beforeEach((to, from, next) => {
    LoadingBar.start();
    next();
})

router.afterEach(route => {
    window.scrollTo(0, 0)
    LoadingBar.finish();
})

router.beforeEach((to, from, next) => {
    const lang = localStorage.Lang || 'en'
    if (lang == 'en') {
        document.title = 'HWelltech'
    } else {
        document.title = '恒为信息科技'
    }

    next();
})

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')